import config from './config';
import React, { Component } from 'react';
import SwaggerUi from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css'; //fix of swagger ui issue AUSS-820
import './swagger-ui-override.css';
import { getBaseUrlWithoutProtocolFromConfig } from './utils/url_helpers';
import { DEPRECATED_ENGINES } from './constants/Engines';

const enginesList = [
  'Account',
  'Billing',
  'Business Activity',
  'CPQ',
  'Customer',
  'Delivery',
  'Event Notifications Publisher',
  'Legal',
  'Marketing',
  'Product',
  'Provisioning',
  //TODO: To be deleted once usage engine is deprecated
  'Usage'
];

class SwaggerDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      swaggerSpecs: {}
    };
  }

  componentDidMount() {}

  handleChange = e => {
    let newUrl = e.target.value;
    fetch(newUrl).then(res =>
      res.json().then(data => {
        data.host = getBaseUrlWithoutProtocolFromConfig(config.biztechApi);
        this.setState({ url: newUrl, swaggerSpecs: data });
        SwaggerUi({
          dom_id: '#swaggerContainer',
          spec: data
        });
      })
    );
  };

  render() {
    return (
      <div>
        <aui-nav>
          {enginesList
            .filter(
              engineName =>
                !DEPRECATED_ENGINES.includes(engineName.toLowerCase())
            )
            .map(engineName => (
              <button
                onClick={this.handleChange.bind(this)}
                value={getSwaggerS3Link(engineName)}
              >
                {engineName}
              </button>
            ))}
        </aui-nav>
        <div id="swaggerContainer" />
      </div>
    );
  }
}

function getSwaggerS3Link(engineName) {
  return `${config.swaggerLocation}${engineName
    .toLowerCase()
    .replace(/ /g, '_')}_swagger.json`;
}

export default SwaggerDisplay;
